// Dokumentace: https://cncenter.atlassian.net/wiki/spaces/KB/pages/120225817/Diskuze+2023

import { forumShowMore } from './forumShowMore';
import { forumAddComment } from './forumAddComment';
import { forumReplyToComment } from './forumReplyToComment';
import { forumAnchorScroll } from './forumAnchorScroll';
import { forumEditComment } from './forumEditComment';
import { forumDeleteComment } from './forumDeleteComment';
import { forumNotifyComment } from './forumNotifyComment';
import { forumHarmlessComment } from './forumHarmlessComment';
import { forumShareComment } from './forumShareComment';
import { forumTimer } from './forumTimer';
import { forumLikeComment } from './forumLikeComment';
import { forumAdminTip } from './forumAdminTip';
import { forumBadWords } from './forumBadWords';
import { forumVerticalLine } from './forumVerticalLine';
import { adminActionsBar } from './forumElements';
import { initForumHateList } from './forumHateList';

const Forum = (): void => {
  // Tlačítka 'Další komentáře(n)'
  // Musí být zavoláno před forumAnchorScroll(), protože by chyběl eventListener!
  forumShowMore();

  // Scroll na daný komentář pomocí kotvy v url
  forumAnchorScroll();

  // Inicializovat časovač
  forumTimer();

  // Odeslat komentář
  forumAddComment();

  // Odpověď(i) na komentář
  forumReplyToComment();

  // Editace komentářů
  forumEditComment();

  // Nahlašování komentářů
  forumNotifyComment();

  // Sdílení
  forumShareComment();

  // 'Tleskáček'
  forumLikeComment();

  // výška vertikálních vodících line na reagující komentáře
  forumVerticalLine();
  window.addEventListener('resize', () => {
    forumVerticalLine();
  });

  // Blokování uživatelů
  const threadIdElement = document.querySelector('[data-thread-id]');
  if (threadIdElement) {
    const threadId = threadIdElement.getAttribute('data-thread-id');
    if (threadId) {
      initForumHateList(threadId);
    }
  }

  // Administrátorské funkce
  if (adminActionsBar) {
    // 'Výběr redakce' / ADMIN
    forumAdminTip();

    // Mazání komentářů / ADMIN
    forumDeleteComment();

    // Potvrzení nezávadných komentářů / ADMIN
    forumHarmlessComment();

    // 'Slovník zakázaných výrazů'
    forumBadWords();
  }
};

export default Forum;
